// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/loading/index.css
// module id = 454
// module chunks = 153